import classNames from 'classnames';

import styles from './CheckMark.module.css';

import { Check } from '../../../icons';

interface CheckMarkProps {
  checked?: boolean;
  disabled?: boolean;
}
export function CheckMark(props: CheckMarkProps) {
  const className = classNames(styles.root, {
    [styles.checked]: props.checked,
    [styles.disabled]: props.disabled,
  });
  return (
    <span aria-hidden className={className}>
      <Check fill="white" height={12} />
    </span>
  );
}
